<template>
  <div id="honor" class="honor">
    <div class="honor-title">全部荣誉</div>
    <div class="honor-list">
      <div class="honor-item" v-for="(item, index) in honorList" :key="index">
        <div class="honor-item__img">
          <img :src="item.src" alt="" />
        </div>
        <div class="honor-item_title">{{ item.honorName }}</div>
        <div class="honor-item_desc">{{ item.honorInfo }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { honorList } from '@/config/about';
import { Mixins } from '@ireader/core-lib';
export default {
  name: 'Honor',
  mixins: [Mixins.sdd()],
  data: function () {
    return {
      honorList: []
    };
  },
  async mounted() {
    try {
      const res = await this.$getSdd('zycom/honor_list');
      this.honorList = res || honorList;
      this.$nextTick(() => {
        this.$emit('prepared');
      });
    } catch (e) {
      this.honorList = honorList;
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/function.scss';

.honor {
  width: 992px;
  margin: 0 auto;
  padding-bottom: 120px;
}

.honor-list {
  display: flex;
  flex-wrap: wrap;
}

.honor-title {
  font-size: 40px;
  line-height: 60px;
  color: #000;
  font-weight: 500;
  text-align: center;
  padding: 48px 0;
}

.honor-item {
  width: 320px;
  margin-left: 16px;
  margin-top: 124px;
  &:nth-child(3n - 2) {
    margin-left: 0;
  }
  &:nth-child(-n + 3) {
    margin-top: 0;
  }
}

.honor-item__img {
  height: 240px;
  overflow: hidden;
  img {
    display: block;
    width: 100%;
    height: 100%;
  }
}

.honor-item_title {
  margin-top: 32px;
  padding: 0 16px;
  font-size: 16px;
  line-height: 24px;
  color: #000;
}

.honor-item_desc {
  margin-top: 16px;
  padding: 0 16px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.55);
}
.S{
  .honor{
    box-sizing: border-box;
    padding: rem(72) rem(48);
    width: 100%;
  }
  .honor-title{
    display: none;
  }
  .honor-list{
    justify-content: space-between;
  }
  .honor-item{
    width: rem(464);
    height: rem(532);
    margin-left: 0;
    margin-top: 0;
    margin-bottom: rem(32);
    &__img{
      height: rem(348);
    }
    &_title{
      line-height: rem(54);
      padding: rem(32) 0 rem(40);
      font-size:rem(36);
      color:#333;
      margin: 0 auto;
      text-align: left;
    }
    &_desc{
      display: none;
    }
  }
}
</style>
